/**
 * Lista mensal de contas a pagar com accordion por mês.
 */

import React, { useState } from 'react'
import { ChevronDown, Receipt } from 'lucide-react'
import { formatDateOnly } from '../../../../utils/dateUtils'
import './PayablesMonthlyList.css'

const STATUS_LABELS = {
  pending: 'Em aberto',
  overdue: 'Vencida',
  paid: 'Paga',
  cancelled: 'Cancelada'
}

function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value || 0)
}

function PayablesMonthlyList({ months = [], onItemClick }) {
  const [expanded, setExpanded] = useState(() => {
    if (months.length > 0) return { [months[0].monthKey]: true }
    return {}
  })

  const toggleMonth = (monthKey) => {
    setExpanded((prev) => ({ ...prev, [monthKey]: !prev[monthKey] }))
  }

  if (!months.length) {
    return (
      <div className="payables-monthly-list payables-monthly-list--empty">
        <p>Nenhum título no período selecionado</p>
      </div>
    )
  }

  return (
    <div className="payables-monthly-list">
      <div className="payables-monthly-list-header">
        <h3 className="payables-monthly-list-title">
          <Receipt size={16} />
          Lista mensal
        </h3>
        <p className="payables-monthly-list-subtitle">
          Títulos agrupados por mês de vencimento
        </p>
      </div>

      <div className="payables-monthly-list-body">
        {months.map((month) => {
          const isOpen = expanded[month.monthKey]
          return (
            <div key={month.monthKey} className={`payables-monthly-list-month${isOpen ? ' is-open' : ''}`}>
              <button
                type="button"
                className="payables-monthly-list-month-trigger"
                onClick={() => toggleMonth(month.monthKey)}
                aria-expanded={isOpen}
              >
                <ChevronDown size={16} className={`payables-monthly-list-chevron${isOpen ? ' is-open' : ''}`} />
                <span className="payables-monthly-list-month-label">{month.monthLabel}</span>
                <span className="payables-monthly-list-month-meta">
                  {month.count} {month.count === 1 ? 'título' : 'títulos'}
                </span>
                <span className="payables-monthly-list-month-total">{formatCurrency(month.total)}</span>
              </button>

              {isOpen && (
                <div className="payables-monthly-list-items">
                  {month.items.length === 0 ? (
                    <p className="payables-monthly-list-empty-month">Sem títulos neste mês</p>
                  ) : (
                    <table className="payables-monthly-list-table">
                      <thead>
                        <tr>
                          <th>Descrição</th>
                          <th>Fornecedor</th>
                          <th>Vencimento</th>
                          <th>Status</th>
                          <th className="align-right">Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {month.items.map((item) => (
                          <tr
                            key={item.id}
                            className={item.isOverdue ? 'is-overdue' : ''}
                            onClick={() => onItemClick?.(item)}
                            role={onItemClick ? 'button' : undefined}
                            tabIndex={onItemClick ? 0 : undefined}
                          >
                            <td>{item.description}</td>
                            <td>{item.supplierName}</td>
                            <td>{formatDateOnly(item.dueDate)}</td>
                            <td>
                              <span className={`payables-monthly-list-status status-${item.status}`}>
                                {STATUS_LABELS[item.status] || item.status}
                              </span>
                            </td>
                            <td className="align-right">{formatCurrency(item.openAmount > 0 ? item.openAmount : item.amount)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PayablesMonthlyList
